import { useQuery } from '@apollo/client/react';

import { getSiblingPayments } from '../../services/PaymentService';

export const useSiblingPayments = (paymentId) => {
  const { data, loading, error } = useQuery(getSiblingPayments, {
    fetchPolicy: 'cache-and-network',
    variables: { id: paymentId }
  });

  return { siblingsPayments: data?.payments || [], loading, error };
};
